export const AGENT_SERVICE_BASE_URL =
  '/dcfront/member/memberRegist/?entry_id=1&carry_id=5100002287&carry_class=k' as const;
